module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1250.7347932b.png";